import Tr from 'translations/Translations';

export const VALUES = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
}

export const AUDIT_TASK_TYPE_LABELS = {
    [VALUES.INTERNAL]: Tr('audit_task_type_internal'),
    [VALUES.EXTERNAL]: Tr('audit_task_type_external')
}

const createItem = (e) => ({
    label: AUDIT_TASK_TYPE_LABELS[e],
    value: e,
})

export default Object.values(VALUES).map(x => createItem(x))
